import RequestService from './request';

interface IndexModpackRequest {
    platform: string;
    modpack_id: string;
}

class MinecraftModpacksService {
    index(data: IndexModpackRequest): Promise<void> {
        return RequestService.post('/minecraft-modpacks/index', data);
    }
}

export default new MinecraftModpacksService();
